import React from 'react'

import {
  cto1Image,
  cto2Image,
  cto3Image,
  cto4Image,
} from 'Assets/_Legacy/CtoPage'

export const CTOS = [
  {
    id: 1,
    title: 'Volodymyr',
    description: (
      <>
        Volodymyr positions himself as CTO with an entrepreneurial mindset. This
        allowed him to drive technical excellence to various products during his
        12 years of combining leadership, software architecture, development,
        and resources management.
        <br />
        <br />
        Volodymyr founded and led StartupCraft (web, mobile, and blockchain
        development company) in 2015 and Synchronos (ERP for remote teams) in
        2018 to help constantly deliver outstanding solutions. Volodymyr helped
        to build more than 150 different projects with clientele including top
        Fortune 100 companies and developed Blockchain patent-pending solutions.
        <br />
        <br />
        Volodymyr is considered an expert in workforce management, productivity,
        telecom, and fintech solutions. He has a Bachelor&apos;s Degree in
        Computer Engineering and a Specialist Degree in Computer Systems and
        Networks, acquired at Sevastopol National Technical University.
      </>
    ),
    avatar: cto1Image,
  },
  {
    id: 2,
    title: 'Dmitrii',
    description: (
      <>
        Dmytry is a Senior Software Engineer and an expert in Blockchain
        technology and building highly effective architectures and algorithms.
        <br />
        <br />
        Finding passion in the work utilizes his attention to detail and
        thoroughness to achieve goals. Enthusiastic about spending free time
        exploring and experimenting with AI-related technologies.
        <br />
        <br />
        He has 16 years of experience and has graduated in Robotics and
        Mechatronics.
      </>
    ),
    avatar: cto2Image,
  },
  {
    id: 3,
    title: 'George',
    description: (
      <>
        George entered the industry 14 years ago as a software engineer and has
        already developed extensive experience in the different modern
        technologies stacks, including Blockchain and Data Science with Graph
        Databases.
        <br />
        <br />
        It is hard to surprise him as he can adapt quickly to any new challenge.
        George holds a Master of Science degree in System Analysis and
        Management. In his free time, George is managing another big project -
        his 2 kids. They help balance a stressful startup environment and charge
        him with positive energy.
        <br />
        <br />
        George holds a Master of Science degree in System Analysis and
        Management.
      </>
    ),
    avatar: cto3Image,
  },
  {
    id: 4,
    title: 'Sergey',
    description: (
      <>
        Sergey is a mobile applications expert and system architect. Sergey has
        been living with code in mind for the past 10 years. His main focus lies
        in mobile applications as he is considered himself a React Native guru.
        He constantly improves his skills by experimenting with bleeding edge
        technologies, and architecture patterns and always follow the latest
        trends.
        <br />
        <br />
        Sergey holds a Bachelor&apos;s degree in Applied Informatics and
        Software Engineering.
      </>
    ),
    avatar: cto4Image,
  },
]
